import HighSchool from "@/components/Icons/HighSchool";
import University from "@/components/Icons/University";
import ChangeCareers from "@/components/Icons/ChangeCareers";
import SciTechPivot from "@/components/Icons/SciTechPivot";
import Brain from "@/components/Icons/Brain";

/* ------------------------------------------------------------------------------------ */

export default function WorkOnEmu() {
	return (
		<section className="sponsor-section">
			<header>
				<h2>Work on emulation</h2>
				<p>Hands-on baby</p>
			</header>

			<ol>
				<li className="card">
					<header className="accent-blue">
						<h3>I'm in high school</h3>
						<div className="card-icon-container accent-blue-a15">
							<HighSchool size={27} />
						</div>
					</header>

					<ul>
						<li>
							Join a lab at a local university that does work in one of the
							fields listed in the <em>What needs doing</em> section below
						</li>
						<li>Join a summer research program</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-blue-90">
						<h3>I'm in university</h3>
						<div className="card-icon-container accent-blue-a15">
							<University size={27} />
						</div>
					</header>

					<ul>
						<li>
							Join a lab that does work in one of the fields listed in the <em>What needs doing</em> section below
						</li>
						<li>Do a relevant summer internship</li>
						<li>Major in a relevant field</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink-90">
						<h3>I want to change careers</h3>
						<div className="card-icon-container accent-pink-a15">
							<ChangeCareers size={27} />
						</div>
					</header>

					<ul>
						<li>
							Get relevant experience in a different role within your current
							organization, if possible
						</li>
						<li>Contribute to open-source annotation projects</li>
						<li>Apply for lab tech roles</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink-85">
						<h3>I work in science/tech and want to pivot</h3>
						<div className="card-icon-container accent-pink-a15">
							<SciTechPivot size={27} />
						</div>
					</header>

					<ul>
						<li>
							Get relevant experience in a different role within your current
							organization, if possible
						</li>
						<li>Map your skills to an emulation bottleneck / building block</li>
						<li>
							Apply for visiting-researcher or sabbatical slots in emulation
							labs
						</li>
						<li>Contribute to relevant open-source projects</li>
					</ul>
				</li>

				<li className="card">
					<header className="accent-pink">
						<h3>I work in a brain-adjacent field</h3>
						<div className="card-icon-container accent-pink-a15">
							<Brain size={27} />
						</div>
					</header>

					<ul>
						<li>Apply for joint projects / grants with emulation groups</li>
						<li>Contribute existing toolchains as open-source</li>
						<li>Start a company that tackles an emulation bottleneck</li>
					</ul>
				</li>
			</ol>
		</section>
	);
}
